import * as React from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import KpiandRR from "./BizLeaderMobileModules/KpiandRR/KpiandRR";
import Recent from "./BizLeaderMobileModules/Recent/Recent";
import {
  spacing,
  typography,
  colors,
} from "../../../../../../assets/styles/tokens";
import Brands from "./BizLeaderMobileModules/Brands/Brands";
import Budget from "./BizLeaderMobileModules/Budget/Budget";
import { AppBar } from "@mui/material";
import BLDWebsite from "./BizLeaderMobileModules/BLDWebsite/BLDWebsite";
import Keywords from "./BizLeaderMobileModules/Keywords/Keywords";
import { useSearchParams } from "react-router-dom";
import Conversions from "./BizLeaderMobileModules/Conversions/Conversions";

export default function BizLeaderMobileDashboardTabs() {
  const tabConfig = [
    { label: "KPI’s & RR", value: "bizleaderDBKPIsRR", trackerId: "643" },
    { label: "Recent", value: "bizleaderDBRecent", trackerId: "647" },
    { label: "Brands", value: "bizleaderDBBrands", trackerId: "649" },
    { label: "Budget", value: "bizleaderDBBudget" },
    { label: "Keywords", value: "bizleaderDBKeywords", trackerId: "662" },
    { label: "Conversions", value: "bizleaderDBConversions", trackerId: "668" },
    { label: "Website", value: "bizleaderDBWebsite" },
  ];
  const [searchParams, setSearchParams] = useSearchParams();

  const currentTabParam = searchParams.get("tabName");

  const initialIndex = tabConfig.findIndex(
    (tab) => tab.value === currentTabParam,
  );

  const [value, setValue] = React.useState(
    initialIndex !== -1 ? initialIndex : 0,
  );

  const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
    const newTabValue = tabConfig[newValue].value;
    searchParams.set("tabName", newTabValue);
    setSearchParams(searchParams);
  };

  interface TabPanelProps {
    children?: React.ReactNode;
    value: number;
    index: number;
  }

  function TabPanel({ children, value, index }: TabPanelProps) {
    return (
      <div hidden={value !== index}>
        {value === index && <Box sx={{ pt: 1 }}>{children}</Box>}
      </div>
    );
  }

  return (
    <>
      <Box sx={{ height: "93vh", overflowY: "auto" }}>
        <AppBar
          position="sticky"
          sx={{
            bgcolor: "background.paper",
            // borderBottom: `1px solid ${colors.GrayLightMode[200].$value}`,
          }}
        >
          <Tabs
            value={value}
            onChange={handleChange}
            variant="scrollable"
            scrollButtons="auto"
            sx={{
              "& .MuiTabs-scrollButtons": {
                color: colors.GrayDarkMode[700].$value,
              },
            }}
            TabIndicatorProps={{
              sx: {
                backgroundColor: colors.Brand[600].$value,
                height: spacing.Spacing.xxs.$value,
              },
            }}
          >
            {tabConfig.map((tab, index) => (
              <Tab
                key={tab.value}
                label={tab.label}
                disableRipple
                {...(tab.trackerId && value === index
                  ? { "data-tracker": tab.trackerId }
                  : {})}
                sx={{
                  color: colors.GrayDarkMode[700].$value,
                  textTransform: "none",
                  fontWeight: typography.Font_weight.Regular.$value,
                  "&.Mui-selected": {
                    color: "#181D27",
                    fontWeight: typography.Font_weight.Medium.$value,
                  },
                  "&:hover": { backgroundColor: "transparent" },
                  "&:first-of-type": {
                    marginLeft: spacing.Spacing["6xl"].$value,
                  },
                }}
              />
            ))}
          </Tabs>
        </AppBar>

        {/* 🔽 TAB CONTENTS */}
        <TabPanel value={value} index={0}>
          <KpiandRR />
        </TabPanel>

        <TabPanel value={value} index={1}>
          <Recent />
        </TabPanel>

        <TabPanel value={value} index={2}>
          <Brands />
        </TabPanel>

        <TabPanel value={value} index={3}>
          <Budget />
        </TabPanel>

        <TabPanel value={value} index={4}>
          <Keywords />
        </TabPanel>

        <TabPanel value={value} index={5}>
          <Conversions />
        </TabPanel>

        <TabPanel value={value} index={6}>
          <BLDWebsite />
        </TabPanel>
      </Box>
    </>
  );
}
